export type Cache = Record<string, any>;

export interface MemoryCache {
  add(item: object, ...keys: string[]): void;

  clear(key?: string): void;

  get(): Cache;

  remove(...keys: string[]): void;
}

/**
 * Create a memory cache
 */
export function createMemoryCache(initialCache: Cache = {}): MemoryCache {
  let cache: Cache = copy(initialCache);

  return {
    add,
    clear,
    get,
    remove,
  };

  /**
   * Add an item to the cache
   */
  function add(item: Cache, ...keys: string[]): void {
    let obj: Cache = cache;

    keys.forEach((key) => {
      if (!(key in obj)) {
        obj[key] = {};
      }

      obj = obj[key];
    });

    Object.assign(obj, item);
  }

  /**
   * Clear the cache
   */
  function clear(key?: string): void {
    if (key) {
      cache[key] = {};
    } else {
      cache = copy(initialCache);
    }
  }

  /**
   * Get a copy of the cache
   */
  function get(): Cache {
    return copy(cache);
  }

  /**
   * Remove marking from the marking cache
   */
  function remove(...keys: string[]): void {
    let obj: Cache = cache;

    const lastKey = keys.length - 1;

    keys.forEach((key, index) => {
      if (!(key in obj)) {
        return;
      }

      if (index !== lastKey) {
        obj = obj[key];
      }
    });

    delete obj[keys[lastKey]];
  }

  /**
   * Return copy of the object provided
   */
  function copy(obj: Cache): Cache {
    return JSON.parse(JSON.stringify(obj));
  }
}
